import SyncBtn from "../assets/images/icon/refresh.svg?react";
import EditBtn from "../assets/images/icon/edit.svg?react";
import DeleteBtn from "../assets/images/icon/delete.svg?react";
import Map from "../assets/images/icon/map.svg?react";
import MapSolid from "../assets/images/icon/map-solid.svg?react";
import Close from "../assets/images/icon/close.svg?react";
import View from "../assets/images/icon/view.svg?react";
import Filter from "../assets/images/icon/filter.svg?react";
import DocExcel from "../assets/images/icon/doc_exel.svg?react";
import PrintReport from "../assets/images/icon/print.svg?react";
import PDF from "../assets/images/icon/pdf.svg?react";
import RightArrrow from "../assets/images/icon/right_arrow.svg?react";
import DocCSV from "../assets/images/icon/CSV_file.svg?react";
import History from "../assets/images/icon/history.svg?react";
import RightTick from "../assets/images/icon/rightTick.svg?react";
import ChangePass from "../assets/images/icon/change_password.svg?react";
import Watch from "../assets/images/icon/watch.svg?react";
import FacebookSolid from "../assets/images/icon/facebook.svg?react";
import TwitterSolid from "../assets/images/icon/twitter.svg?react";
import CareerCompass from "../assets/images/icon/Career-Compass.svg?react";
import SkillAssessment from "../assets/images/icon/Skill-Assessment.svg?react";
import InterestAssessment from "../assets/images/icon/Interest-Assessment.svg?react";
import { SolutionOutlined, UnlockOutlined } from "@ant-design/icons";

interface IconProps {
  icon: string; //make the clear type to make switch
  color?: string;
  width?: number;
}

const SVGIcon = ({ icon, color = "#696b71", width = 14 }: IconProps) => {
  // In this case you have to think about the switch and types in typescript.
  const Icons: any = {
    refresh: <SyncBtn fill={color} width={width} height={width} />,
    close: <Close fill={color} width={width} height={width} />,
    edit: <EditBtn fill={color} width={width} height={width} />,
    delete: <DeleteBtn fill={color} width={width} height={width} />,
    view: <View fill={color} width={width} height={width} />,
    map: <Map fill={color} width={width} height={width} />,
    mapSolid: <MapSolid fill={color} width={width} height={width} />,
    filter: <Filter fill={color} width={width} height={width} />,
    DocExcel: <DocExcel fill={color} width={width} height={width} />,
    DocCSV: <DocCSV fill={color} width={width} height={width} />,
    PrintReport: <PrintReport fill={color} width={width} height={width} />,
    PDF: <PDF fill={color} width={width} height={width} />,
    right_arrow: <RightArrrow fill={color} width={width} height={width} />,
    history: <History fill={color} width={width} height={width} />,
    rightTick: <RightTick fill={color} width={width} height={width} />,
    changePass: <ChangePass fill={color} width={width} height={width} />,
    watch: <Watch fill={color} width={width} height={width} />,

    FacebookSolid: <FacebookSolid fill={color} width={width} height={width} />,
    TwitterSolid: <TwitterSolid fill={color} width={width} height={width} />,
    ChangePassword: <UnlockOutlined style={{color:color}} width={width} height={width}  />,
    InterestAssessment: (
      <InterestAssessment fill={color} width={width} height={width} />
    ),
    SkillAssessment: (
      <SkillAssessment fill={color} width={width} height={width} />
    ),
    CareerCompass: (
      <CareerCompass fill={color} width={width} height={width} />
    ),
    ExamIcon: <SolutionOutlined  style={{color:color,fontSize:'1.8rem'}} width={width} height={width} />,
  };
  return Icons[icon];
};

export default SVGIcon;
